import { SUPPORTS_WEBP } from 'explora-global';
import React, { ReactNode } from 'react';
import './WithBackground.scss';

interface WithBackgroundInterface {
  imageName: string;
  children: ReactNode;
  position?: string;
}

const WithBackground = ({ imageName, position = 'center', children }: WithBackgroundInterface) => {
  let backgroundImage = `${process.env.PUBLIC_URL}/assets/${imageName}.webp`;

  if (!SUPPORTS_WEBP) {
    backgroundImage = require(`shared/assets/png/${imageName}.png`);
  }

  return (
    <section
      className="with-background-hoc"
      style={{ backgroundImage: `url(${backgroundImage})`, backgroundPosition: `46% ${position}` }}
    >
      <div>{children}</div>
    </section>
  );
};

export default WithBackground;
